import { client } from './client';

export const getCurrentUser = () => client('users/current', { method: 'GET' });
